export default __webpack_public_path__ + "static/media/Monk's Bracers of the Earthen Prison.0212a6b9.jpg";